import React, { useContext, useState } from "react";
import styled from "styled-components";
import { Tab, Tabs } from "@blueprintjs/core";

import { Code } from "@components";
import { OrgContext } from "@providers";
import { Feature } from "@utils/feature";

import { VisibilityToggle } from "../RuleShareDialog/VisibilityToggle";

import GitHubImportRulesCode, {
  CLIPublishCommand,
} from "./GitHubImportRulesCode";

interface Props {
  name: string;
}

const DialogContainer = styled.div`
  padding: 0px 24px 0px 24px;
  width: 800px;
`;

const PanelRow = styled.div`
  margin: 8px 0;
  /* border-top: 1px solid #cbcbcb; */
  /* background-color: white; */
  border-radius: 6px;
`;

type ImportMethod = "github" | "gitlab" | "cli";

const ImportRulesDialog: React.FC<Props> = ({ name }) => {
  // Required to block out non-team-tier permissions:
  const { org } = useContext(OrgContext);
  const hasTeamsTier = Feature.hasTeamsTier({ org });

  const [ci, setCi] = useState<ImportMethod>("cli");
  const [visibility, setVisibility] = useState<
    "unlisted" | "org_private" | "public"
  >("unlisted");

  return (
    <DialogContainer>
      <PanelRow>
        <div>
          <div style={{ margin: "0px", marginBottom: "12px" }}>
            <Tabs
              onChange={(val) => {
                setCi(val as ImportMethod);
              }}
            >
              <Tab id="cli" title="CLI" />
              <Tab id="github" title="GitHub Actions" />
            </Tabs>
          </div>

          <p>Import multiple rules to Semgrep App with the CLI.</p>

          <div style={{ display: "flex", gap: "16px", marginBottom: "12px" }}>
            <VisibilityToggle
              hasTeamsTier={hasTeamsTier}
              visibility={visibility}
              setAction={setVisibility}
            ></VisibilityToggle>
          </div>

          {ci === "github" && (
            <GitHubImportRulesCode visibility={visibility} name={name} />
          )}
          {ci === "cli" && (
            <>
              1. Login to your account
              <Code copyable>semgrep login</Code>
              <br />
              2. Publish the folder with your rules
              <Code copyable>
                <CLIPublishCommand visibility={visibility} name={name} />
              </Code>
            </>
          )}
        </div>
      </PanelRow>
    </DialogContainer>
  );
};

export default ImportRulesDialog;
